import React, {Component} from 'react';
import userImage from '../../../assets/img/128x128.jpg';
import api from '../../../utils/api';
import moment from 'moment';




class Notifications extends Component {
    
    getUserImage = (profile) => {
        if(profile){
            if(profile.smImage){
                return api.makeFileURL(profile.smImage);
            }else if(profile.image){
                return api.makeFileURL(profile.image);
            }else{
                return userImage;
            }
        }else{
            return userImage;
        }
    }

    componentDidMount(){
        let {courseUser, notifications} = this.props;
        if(courseUser[0]){
            this.props.initialNotifications(courseUser[0].courseId, courseUser[0].created, courseUser[0].profileId, this.props.user.id);
        }
    }

    loadNotifications = () => {
        let {courseUser, notifications} = this.props;
        if(courseUser[0]){
            this.props.loadNotifications(courseUser[0].courseId, courseUser[0].created, courseUser[0].profileId, notifications.length, this.props.user.id);
        }
    }


    render(){
        let {notifications, checkForMoreNotifications} = this.props;

        return (
            <div id="content-container" className="content-wrapper">
                <section className="content">
                <div className="panel customPanel">
                    <div className="panel-body no-padding darkest-panel" style={{ background: "#181818 !important" }}>
                
                    <div className="sp-20">
                        <div className="clearfix">
                            <div className="RFH">
                                <div>
                                    <p className="font-24 text-white sm-bottom30">Notifications</p>
                                </div>

                            </div>

                        </div>

                            <table className="table" style={{background: "#181818"}}>
                            
                            <tbody>
                                <tr>
                                    <th style={{width: "90px"}}></th>
                                    <th>Description</th>
                                    <th style={{width: "190px"}}><i className="zmdi zmdi-calendar font-24"></i></th>
                                </tr>
                                
                                
                                {notifications ?
                                notifications.map(n => {
                                    if(n.Profile){
                                        return (
                                            
                                            
                                            
                                            <tr>
                                                <td className="text-center">
                                                    <div className="th-wrapper" data-toggle="popover" data-trigger="hover" title="Popover title" data-content="And here's some amazing content. It's very engaging. Right?">
                                                        <img src={this.getUserImage(n.Profile)} alt="User" />
                                                        <span className="badge badge-danger">{n.Profile.role}</span>
                                                    </div>
                                                </td>
                                                <td style={{verticalAlign: "middle"}}>
                                                    <div className="flex space-between text-left">
                                                        <div className="font-14">
                                                            <h3 className="font-16 sm-top0 text-white">{n.Profile.name ? n.Profile.name : n.Profile.email}</h3>
                                                            {n.Profile.id === this.props.profile.id ?
                                                                <p className="hoverable-text font-300">{n.content}</p>
                                                            :
                                                                <p className="hoverable-text font-300">{n.content.replace(/You were/g, n.Profile.name + ' was').replace(/your/g, 'their')}</p>
                                                            }
                                                        </div>
                                                    </div>
                                                </td>
                                                <td style={{verticalAlign: "middle"}}> {moment(n.createdAt).from(moment())}<br /><span className="font-10">{moment(n.createdAt).format('MMM DD YYYY @ HH:mm')}</span></td>
                                            </tr>
                                        )
                                    }else{
                                        return null
                                    }
                                })

                                : null}
                                
                                </tbody>
                                                            
                            </table>

                            {checkForMoreNotifications ?
                                <div className="text-center">
                                    <button className="btn btn-primary" onClick={e => {
                                        if(checkForMoreNotifications){
                                            this.loadNotifications();
                                        }
                                    }}>Load More</button>
                                </div>
                                : null
                            }
                           
                    </div>


                    </div></div>
               
                </section>
            </div>
        )
    }
}

export default Notifications;


// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardUser/Notifications.js